import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import SiteLayout from "@/components/feature/SiteLayout";
import { genres } from "@/mocks/movies";
import { siteInfo } from "@/mocks/site";

export default function AboutPage() {
  return (
    <SiteLayout>
      <Seo
        title="关于我们与免责声明 - 免费电影在线观看"
        description="了解免费电影在线观看的网站定位、内容范围、联系方式与免责声明，我们致力于为用户提供实用的免费高清电影资源导航与观影体验。"
        keywords="免费电影在线观看,关于我们,网站介绍,免责声明,高清电影平台"
      />

      <div className="border-b border-background-200 bg-primary-50">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
          <nav className="flex items-center gap-1.5 text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-600 cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="mt-3 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            关于 {siteInfo.name}
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            一个专注于免费高清电影资源发现与观看体验的在线影视平台
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2 space-y-8">
            <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                网站介绍
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                {siteInfo.name} 是一家专注于免费、高质量在线影视资源的平台，面向广大喜爱电影的影迷群体。
                我们聚合了涵盖最新热门影片与经典大片的丰富电影资源，覆盖动作、爱情、科幻、喜剧、悬疑、
                恐怖、动画、剧情、战争、犯罪等多种类型，帮助用户快速找到并观看心仪影片。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                通过分类浏览、多维筛选、热门榜单与关键词搜索，我们希望让发现好电影这件事变得简单而高效。
                无论你是想追最新上映的高清热片，还是重温经典之作，都能在这里轻松找到。
              </p>
              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
                {[
                  { icon: "ri-film-line", value: "26+", label: "精选影片" },
                  { icon: "ri-apps-2-line", value: "10", label: "电影分类" },
                  { icon: "ri-gift-line", value: "100%", label: "免费观看" },
                ].map((item) => (
                  <div
                    key={item.label}
                    className="flex items-center gap-3 rounded-lg bg-background-50 p-4"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-700">
                      <i className={item.icon} />
                    </span>
                    <div>
                      <p className="font-heading text-xl font-extrabold text-foreground-950">
                        {item.value}
                      </p>
                      <p className="text-xs text-foreground-500">{item.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                联系我们
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                如果您对本站有任何建议、合作意向，或发现内容问题，欢迎通过以下方式与我们取得联系。
                反馈渠道暂未开放在线表单，您可以直接发送邮件联系我们。
              </p>
              <div className="mt-5 flex items-center gap-3 rounded-lg bg-background-50 p-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
                  <i className="ri-mail-line" />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">联系邮箱</p>
                  <p className="font-heading text-sm font-semibold text-foreground-900">
                    {siteInfo.email}
                  </p>
                </div>
              </div>
            </section>

            <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                版权声明与免责声明
              </h2>
              <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-700">
                <p>
                  1. 本站为演示性质的内容展示站点，站内所有影片信息、海报图片及文字介绍均为示例数据，
                  仅用于视觉与交互效果验证，不代表真实可播放的影视资源。
                </p>
                <p>
                  2. 本站不提供任何影片的实际存储与在线播放服务，播放区域仅为演示界面。
                  真实视频播放功能及内容接入为后续待开发功能。
                </p>
                <p>
                  3. 本站尊重并保护知识产权，如相关权利人认为演示内容不当，可联系我们进行处理。
                </p>
                <p>
                  4. 用户在本站产生的收藏等数据仅保存在本地浏览器中，我们不会收集或上传您的个人信息。
                </p>
              </div>
            </section>
          </div>

          <aside className="space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="font-heading text-sm font-bold text-foreground-950">
                站内导航
              </h2>
              <div className="mt-4 flex flex-col gap-0.5">
                {[
                  { to: "/", label: "首页", icon: "ri-home-5-line" },
                  { to: "/search", label: "搜索电影", icon: "ri-search-line" },
                  { to: "/category/动作", label: "浏览分类", icon: "ri-apps-2-line" },
                ].map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
                  >
                    <i className={`${item.icon} text-base`} />
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="font-heading text-sm font-bold text-foreground-950">
                热门分类
              </h2>
              <div className="mt-4 flex flex-wrap gap-2">
                {genres.map((genre) => (
                  <Link
                    key={genre.slug}
                    to={`/category/${genre.slug}`}
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer"
                  >
                    {genre.name}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}